import { DayStatus } from "../hooks/useLocalProgress";
import { getUtcToday } from "../lib/constants";
import styles from "./StreakPopup.module.css";

interface StreakPopupProps {
  current: number;
  pausedDays: number;
  recentDays: { date: string; status: DayStatus }[];
  onClose: () => void;
}

const DAY_LABELS = ["S", "M", "T", "W", "T", "F", "S"];

function StatusIcon({ status }: { status: DayStatus }) {
  if (status === "played") return <span className={styles.checkIcon}>&#10003;</span>;
  if (status === "paused") return <span className={styles.pauseIcon}>&#124;&#124;</span>;
  return null;
}

export function StreakPopup({ current, pausedDays, recentDays, onClose }: StreakPopupProps) {
  const paused = pausedDays > 0;
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <div className={styles.icon}>{paused ? "\u23F8" : "\uD83D\uDD25"}</div>
        <div className={styles.count}>
          {current} Day Streak
        </div>
        {paused && (
          <div className={styles.pausedLabel}>
            {pausedDays === 1 ? "1 Day Paused" : `${pausedDays} Days Paused`}
          </div>
        )}
        <div className={styles.days}>
          {recentDays.map(({ date, status }) => {
            const dayOfWeek = new Date(date + "T00:00:00Z").getUTCDay();
            const isToday = date === getUtcToday();
            const iconClass = `${styles.dayIcon} ${styles[status]}${isToday && status !== "played" ? ` ${styles.todayOutline}` : ""}`;
            return (
              <div key={date} className={styles.day}>
                <span className={styles.dayLabel}>{DAY_LABELS[dayOfWeek]}</span>
                <div className={iconClass}>
                  <StatusIcon status={status} />
                </div>
              </div>
            );
          })}
        </div>
        <p className={styles.hint}>
          {paused
            ? "Your streak is paused. Play today to continue it!"
            : current > 0
              ? "Miss more than two days and your streak will reset."
              : "Solve a puzzle to start your streak!"}
        </p>
      </div>
    </div>
  );
}
